module.exports = __webpack_public_path__ + "static/media/vi.2cca2f61.svg";